var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.025 4.72505c-.1374.14019-.2144.32868-.2144.525 0 .19631.077.3848.2144.525l1.2 1.2c.1402.13742.3287.21439.525.21439s.3848-.07697.525-.21439l2.8275-2.8275c.3771.83339.4913 1.76192.3274 2.66186-.164.89993-.5984 1.72852-1.2452 2.37535-.6468.64682-1.4754 1.08114-2.3753 1.24514-.9.164-1.8285.0498-2.6619-.3274l-5.18249 5.1825c-.29836.2984-.70304.466-1.125.466-.42195 0-.82663-.1676-1.125-.466-.29836-.2983-.46599-.703-.46599-1.125 0-.4219.16763-.8266.46599-1.125l5.1825-5.18245c-.37712-.8334-.49131-1.76193-.32734-2.66186.16397-.89994.59831-1.72853 1.24513-2.37535.64683-.64683 1.4754-1.08117 2.3754-1.24514.8999-.16397 1.8284-.04978 2.6618.32735l-2.82 2.82z",
    stroke: "#b0bec5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTool);
export default __webpack_public_path__ + "static/media/icon_tool.377388cdfc9e47b72af0a2fb80df8162.svg";
export { ForwardRef as ReactComponent };